import * as actions from "./actionsType";

const initialData = {
  loading: false,
  notificationVariablesLength: 0,
  notificationVariables: [], 
  notificationVariableError: ""
};

export default function NotificationVariableReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_NOTIFICATION_VARIABLE:      
      return { ...state, loading: action.payload };

    case actions.GET_NOTIFICATION_VARIABLE:
      return {
        ...state,
        notificationVariables: action.payload.notificationVariables,
        notificationVariablesLength: action.payload.notificationVariablesLength,
      };

    case actions.NOTIFICATION_VARIABLE_FAIL:
      return { ...state, notificationVariableError: action.payload };

    default:
      return state;
  }
}
